import { Box, Center, Loader, Overlay, Text } from '@mantine/core';
import classes from './BulkOperationLoadingMask.module.css';

export function BulkOperationLoadingMask() {
  return (
    <Overlay bg="var(--colors-overlay)" center zIndex={50}>
      <Box bg="var(--colors-paper)" className={classes.loadingWrapper} c="var(--colors-paperReverse)" p="xs">
        <Text ta="center" fz="sm" fw={600} pt="xs" c="var(--colors-paperReverse)">
          Applying Bulk Changes
        </Text>
        <Center className={classes.loadingContent} py="lg">
          <Box className={classes.loadingIndicator}>
            <Loader type="oval" color="var(--colors-successButton)" size="md" />
          </Box>
          <Text fz="xs" fw="500" mt="xs" c="var(--colors-paperReverse)">
            Saving
          </Text>
        </Center>
      </Box>
    </Overlay>
  );
}
